<template lang="pug">
  span.er(ref="root") {{ $get(user, `name`) }}
</template>

<script>
import { toRefs, ref } from '@vue/composition-api'
import { injectRouteState } from '@iez/core'

export default {
  setup () {
    const routeState = injectRouteState()
    const root = ref(null)

    return {
      root,
      ...toRefs(routeState)
    }
  }
}
</script>
